import { render, staticRenderFns } from "./CustomLanguageDropdown.vue?vue&type=template&id=b16e9972&scoped=true"
import script from "./CustomLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./CustomLanguageDropdown.vue?vue&type=script&lang=js"
import style0 from "./CustomLanguageDropdown.vue?vue&type=style&index=0&id=b16e9972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16e9972",
  null
  
)

export default component.exports